"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _sizes = require("@decisiv/design-tokens/lib/iconography/sizes");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var SvgHandshake = function SvgHandshake(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutProperties(_ref, ["size", "color"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    width: _sizes.alias[size],
    height: _sizes.alias[size],
    color: color,
    focusable: "false"
  }, props), _react.default.createElement("path", {
    d: "M7.109 2.169l-.721-.103a1 1 0 00-.513.061L1.372 3.928a1 1 0 01-.743-1.856L5.132.27A3 3 0 016.671.086L9.64.51a1 1 0 01.718 1.503l2.856.858 1.078-1.078a1 1 0 011.414 1.414l-1.5 1.5a1 1 0 01-.994.25L9.059 3.713a1 1 0 00-.802.1L4.885 5.835c.11.098.23.163.358.195.815.204 1.731.115 2.627-.164.329-.103.568-.203.683-.26a1 1 0 011.002.062l6 4a1 1 0 01-1.11 1.664L8.892 7.63c-.128.047-.27.096-.426.144-1.216.38-2.483.502-3.708.196-.665-.166-1.198-.552-1.61-1.072a3.58 3.58 0 01-.6-1.09 1 1 0 01.438-1.165l4.123-2.474zm-.072 11.987a1 1 0 11-1.074 1.688l-5.5-3.5a1 1 0 111.074-1.688l5.5 3.5zm4.018-.488a1 1 0 11-1.11 1.664l-1.5-1a1 1 0 111.11-1.664l1.5 1zM13.6 12.2a1 1 0 11-1.2 1.6l-2-1.5a1 1 0 111.2-1.6l2 1.5z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

SvgHandshake.propTypes = {
  size: _propTypes.default.oneOf(Object.keys(_sizes.alias)),
  color: _propTypes.default.string
};
var _default = SvgHandshake;
exports.default = _default;